import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { AccountInfo } from "@azure/msal-browser";


@Injectable()
export abstract class ICurrentUserService {
    abstract getUser(): AccountInfo | null;
    abstract getUserEmail(): string | null;
    abstract getAccessToken(): Observable<string>;

}
